export default __webpack_public_path__ + "static/media/blogcard9.8a60e19a.png";